<template lang="pug">
    #chat-channel
        v-layout(column ma-3 class="channel-box" v-if="!forOperatingSheet")
            v-toolbar(flat height="45")
                v-toolbar-title.subtitle-2 Channel
            v-divider
            template(v-if="channelsIsEmpty")
                .text-center.font-weight-light.py-4.subtitle-2 Channel Not Found
            v-list(nav dense shaped max-height="150" class="channel-box__item" v-else)
                v-list-item(v-for="channel in channels" :key="channel.id"
                    :input-value="currentChannelId === channel.id"
                    @click="onSelectChannel(channel)")
                    v-list-item-content.subtitle-2 {{channel.title}}
                    v-list-item-action
                        v-layout(row align-center)
                            v-chip(small color="badge" v-if="channel.unreadCount > 0" dark).mr-1 {{channel.unreadCount > 99 ? '99+' : channel.unreadCount}}
        v-layout(column ma-3 class="channel-box")
            v-toolbar(flat height="45")
                v-toolbar-title.subtitle-2 Sub Channel
            v-divider
            template(v-if="!channelsIsEmpty && !currentChannelId")
                .text-center.font-weight-light.py-4.subtitle-2 Please Select Channel
            template(v-else-if="subChannelsIsEmpty")
                .text-center.font-weight-light.py-4.subtitle-2 Not Found
            v-list(nav dense shaped max-height="150" class="channel-box__item" v-else-if="currentChannelId")
                v-list-item(v-for="channel in subChannels" :key="channel.id"
                    :input-value="currentSubChannelId === channel.id"
                    @click="onSelectSubChannel(channel)")
                    v-list-item-content.subtitle-2 {{channel.title}}
                    v-list-item-action
                        v-layout(row align-center)
                            v-chip(small color="badge" v-if="channel.unreadCount > 0" dark).mr-1 {{channel.unreadCount > 99 ? '99+' : channel.unreadCount}}
        v-layout(column ma-3 class="channel-box")
            v-toolbar(flat height="52")
                v-toolbar-title.subtitle-2 Chat Room
                v-spacer
                v-btn(icon @click="onFindChatRoomClick" :disabled="!currentSubChannelId")
                    v-icon mdi-magnify
            v-divider
            template(v-if="!subChannelsIsEmpty && !currentSubChannelId")
                .text-center.font-weight-light.py-4.subtitle-2 Please Select Sub Channel
            template(v-else-if="(!forOperatingSheet && roomsIsEmpty) || (forOperatingSheet && historiesIsEmpty && roomsIsEmpty)")
                .text-center.font-weight-light.py-4.subtitle-2 Not Found
            v-list(nav dense shaped max-height="200" class="channel-box__item" v-else-if="currentSubChannelId")
                v-list-item(v-for="room in rooms" :key="room.id"
                    :input-value="currentRoomId === room.id"
                    @click="onSelectRoom(room)")
                    v-list-item-content.subtitle-2 {{room.title}}
                    v-list-item-action
                        v-layout(row align-center)
                            v-chip(small color="badge" v-if="room.unreadCount > 0" dark).mr-1 {{room.unreadCount > 99 ? '99+' : room.unreadCount}}
                            v-btn(icon small @click.stop="onClickEditChatRoom(room)" v-if="canRenameRoom")
                                v-icon(small) mdi-pencil-outline
                            v-btn(icon small @click.stop="onClickDeleteChatRoom(room)" v-if="canDeleteRoom")
                                v-icon(small) mdi-delete-outline
                template(v-if="forOperatingSheet && !historiesIsEmpty")
                    template(v-for="room in histories")
                        v-list-item(:key="room.id"
                            :input-value="currentRoomId === room.id"
                            @click="onSelectHistory(room)").my-1
                            v-list-item-content
                                v-list-item-title.subtitle-2 {{room.title}}
                                v-list-item-subtitle {{room.completed_at | dateTimeFormat }}
                            v-list-item-action
                                v-chip(small color="badge" v-if="room.unreadCount > 0" dark).mr-1 {{room.unreadCount > 99 ? '99+' : room.unreadCount}}
                        v-divider
        v-layout(column ma-3 v-if="!forOperatingSheet && currentSubChannelId && !historiesIsEmpty")
            v-list(nav dense shaped)
                v-subheader
                    v-layout(column)
                        .font-weight-medium History :&nbsp;
                        .font-weight-black.subtitle-2(v-if="false") {{currentChannel.title}} &#10140; {{currentSubChannel.title}}
                v-divider
                template(v-for="room in histories")
                    v-list-item(:key="room.id"
                        :input-value="currentRoomId === room.id"
                        @click="onSelectHistory(room)").my-1
                        v-list-item-content
                            v-list-item-title.subtitle-2 {{room.title}}
                            v-list-item-subtitle {{room.completed_at | dateTimeFormat }}
                        v-list-item-action
                            v-chip(small color="badge" v-if="room.unreadCount > 0" dark).mr-1 {{room.unreadCount > 99 ? '99+' : room.unreadCount}}
                    v-divider
        v-layout(column ma-3 v-if="forOperatingSheet")
            slot(name="sheet")
</template>

<script>
import isEmpty from "lodash/isEmpty";

export default {
  name: "ChatChannel",
  props: {
    channels: {
      type: Array,
      default: () => []
    },
    subChannels: {
      type: Array,
      default: () => []
    },
    rooms: {
      type: Array,
      default: () => []
    },
    histories: {
      type: Array,
      default: () => []
    },

    currentChannel: {
      type: Object,
      default: () => ({})
    },
    currentSubChannel: {
      type: Object,
      default: () => ({})
    },
    currentRoom: {
      type: Object,
      default: () => ({})
    },

    currentChannelId: {
      type: Number,
      default: 0
    },
    currentSubChannelId: {
      type: Number,
      default: 0
    },
    currentRoomId: {
      type: Number,
      default: 0
    },

    // For Operating Sheet
    forOperatingSheet: {
      type: Boolean,
      default: false
    },

    canDeleteRoom: Boolean,
    canRenameRoom: Boolean
  },
  computed: {
    channelsIsEmpty() {
      return isEmpty(this.channels);
    },
    subChannelsIsEmpty() {
      return isEmpty(this.subChannels);
    },
    roomsIsEmpty() {
      return isEmpty(this.rooms);
    },
    historiesIsEmpty() {
      return isEmpty(this.histories);
    }
  },
  methods: {
    onSelectChannel(channel) {
      this.$emit("channel", channel);
    },
    onSelectSubChannel(channel) {
      this.$emit("sub-channel", channel);
    },
    onSelectRoom(room) {
      this.$emit("room", room);
    },
    onClickEditChatRoom(room) {
      this.$emit("edit-room", room);
    },
    onClickDeleteChatRoom(room) {
      this.$emit("delete-room", room);
    },
    onSelectHistory(history) {
      this.$emit("history", history);
    },
    onFindChatRoomClick() {
      this.$emit("find");
    }
  }
};
</script>

<style scoped lang="scss">
.channel-box {
  border-style: solid;
  border-color: grey;
  border-width: 2px;

  .channel-box__item {
    overflow-y: auto;
  }
}
</style>
